import React from 'react';
import getColor from 'utils/getColor';
import ContentfulRow from 'components/Contentful/ContentfulRow';
import getAlignment from 'utils/getAlignment';
import getJustify from 'components/Contentful/ContentfulRow/utils/getJustify';
import useIsImageColorDark from 'hooks/useIsImageColorDark';
import { ComponentMap } from './ComponentMap';
import { getColumnItemProps } from './ComponentMap/utils/getColumnItemProps';

import { InnerContainer, StyledColumn } from './styles';

const Column = ({
  alignmentDesktop,
  alignmentMobile,
  verticalAlignmentDesktop,
  verticalAlignmentMobile,
  colLength,
  items,
  styles,
  widthMobile,
  widthDesktop,
  parentBackgroundColor,
  orderMobile,
  orderDesktop,
  parentAlignDesktop,
  horizontalContentFlowDesktop,
  horizontalContentFlowMobile,
}) => {
  let hashStyles = {};

  if (styles) {
    Object.keys(styles).forEach(key => (hashStyles[`$${key}`] = styles[key]));
  }

  const {
    $backgroundImage,
    $backgroundColor,
    $border,
    $borderColor,
    $customBackgroundDesktop,
    $customBackgroundMobile,
    $heightMobile,
    $heightDesktop,
    $hideOnDesktop,
    $hideOnMobile,
    $marginMobile,
    $marginDesktop,
    $paddingDesktop,
    $paddingMobile,
    $shadow,
  } = hashStyles || {};

  const backgroundImageUrl = $backgroundImage?.image?.file?.url;
  const bgColor = getColor($backgroundColor || parentBackgroundColor);
  const defaultWidth = 24 / colLength;
  const alignMobile = getJustify(alignmentMobile);
  const alignDesktop = getJustify(alignmentDesktop);
  const verticalAlignMobile = getAlignment(verticalAlignmentMobile);
  const verticalAlignDesktop = getAlignment(verticalAlignmentDesktop);
  const borderColorVar = getColor($borderColor);
  const { imageDark, colorDark } = useIsImageColorDark(backgroundImageUrl, bgColor);

  return (
    <StyledColumn
      {...hashStyles}
      $orderDesktop={orderDesktop}
      $orderMobile={orderMobile}
      sm={widthDesktop || widthMobile || defaultWidth}
      xs={widthMobile || 24}
      className="column-root"
      $customCss={styles?.customStyling?.customStyling}
    >
      <InnerContainer
        {...hashStyles}
        $backgroundColor={bgColor}
        $backgroundImage={backgroundImageUrl}
        $horizontalContentFlowDesktop={horizontalContentFlowDesktop}
        $horizontalContentFlowMobile={horizontalContentFlowMobile}
        $borderColor={borderColorVar}
        $justifyMobile={alignMobile}
        $justifyDesktop={alignDesktop}
        $alignMobile={verticalAlignMobile.flexAlignment}
        $alignDesktop={verticalAlignDesktop.flexAlignment}
        className="column-inner-container"
      >
        {items?.map((item, index) => {
          if (item.__typename === 'ContentfulRow') {
            return (
              <ContentfulRow
                key={index}
                {...item}
                parentBackgroundColor={$backgroundColor || parentBackgroundColor}
                childRow
                parentAlignDesktop={parentAlignDesktop}
              />
            );
          }

          const Component = ComponentMap[item.__typename];

          const customProps = getColumnItemProps(
            item,
            item.__typename,
            bgColor,
            alignDesktop,
            alignMobile,
            colorDark,
            imageDark,
            index,
            $marginDesktop,
            $marginMobile,
            parentBackgroundColor
          );

          const componentProps = {
            ...item,
            ...customProps,
          };

          return Component ? <Component {...componentProps} key={index} /> : null;
        })}
      </InnerContainer>
    </StyledColumn>
  );
};

export default Column;
